import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { ModalDialog } from 'axway-react-ui';
import ModelInfoDialogContent from './ModelInfoDialogContent';

class ModelInfoDialog extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onChange = this.onChange.bind(this);
		this.onOkay = this.onOkay.bind(this);

		// Don't want the change handler to trigger renders
		// so have to store the updated values locally rather
		// than in state.
		this.values = {
			modelName: '',
			modelDescription: '',
			modelConnector: ''
		};

		this.state = {
			form: {
				...this.values
			}
		};
	}

	componentWillMount() {
		this.initializeFormState(this.props);
	}

	componentWillReceiveProps(props) {
		this.initializeFormState(props);
	}

	onChange(data) {
		this.values = {
			...this.values,
			...data
		};
	}

	onOkay() {
		this.props.onOkay(this.values);
	}

	/**
	 * Copy the property values into sate and set the defaults.
	 */
	initializeFormState(props) {
		const { mode, values } = props;
		const form = {};

		if (values.modelSource) {
			let modelSource = values.modelSource;
			if (typeof modelSource === 'string') {
				modelSource = this.props.models[modelSource];
			}

			// If we have a model then show the values from the model.
			form.modelParent = modelSource.parent;
			form.modelName = modelSource.name;
			form.modelConnector = modelSource.connector.name;
			form.modelDescription = modelSource.description;
			// No model, then set the defaults
		} else if (mode === 'compose') {
			form.modelParent = values.modelParent;
			form.modelConnector = 'composite';
		} else if (mode === 'create') {
			form.modelConnector = 'memory';
		}

		this.values = {
			...form
		};
		this.setState({ form });
	}

	/**
	 * The title for the dialog, based on the mode the dialog was opened in.
	 */
	getTitle() {
		switch (this.props.mode) {
			case 'edit':
				return this.intl.formatMsg('Edit Model');
			case 'compose':
				return this.intl.formatMsg('Composite Model');
			case 'create':
				return this.intl.formatMsg('New Model');
			default:
				throw new Error(`Unknown mode: ${this.props.mode}`);
		}
	}

	render() {
		return (
			<ModalDialog
				title={this.getTitle()}
				okayText={this.props.okayText || this.intl.formatMsg('Next')}
				closeText={this.props.closeText || this.intl.formatMsg('Cancel')}
				onClose={this.props.onClose}
				onOkay={this.onOkay}
				show
			>
				<ModelInfoDialogContent
					mode={this.props.mode}
					models={this.props.models}
					values={this.state.form}
					connectors={this.props.connectors}
					onChange={this.onChange}
					onSubmit={this.onOkay}
				/>
			</ModalDialog>
		);
	}
}

ModelInfoDialog.propTypes = {
	mode: PropTypes.oneOf([
		'create', 'edit', 'compose'
	]).isRequired,
	models: PropTypes.object.isRequired,
	values: PropTypes.shape({
		modelParent: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]),
		modelName: PropTypes.string,
		modelConnector: PropTypes.string,
		modelDescription: PropTypes.string
	}),
	connectors: PropTypes.array.isRequired,
	onClose: PropTypes.func.isRequired,
	onOkay: PropTypes.func.isRequired,
	okayText: PropTypes.string,
	closeText: PropTypes.string
};

ModelInfoDialog.defaultProps = {
};

export default injectIntl(ModelInfoDialog);
